import React from 'react';
import { AlertCircle } from 'lucide-react';

export const UnavailableBadge = ({ className = '' }) => (
  <div className={`absolute inset-0 z-20 bg-white/70 backdrop-blur-[1px] flex flex-col items-center justify-center rounded-lg ${className}`}
    data-testid="unavailable-overlay">
    <AlertCircle className="w-5 h-5 text-red-400 mb-1" />
    <span className="text-[10px] font-bold text-red-500 bg-white/80 px-2 py-0.5 rounded-full">Sold Out</span>
  </div>
);

/**
 * Check if a product is sold out / unavailable.
 * A product's own is_sold_out flag is a manual admin override and always wins,
 * regardless of the tenant's show_out_of_stock display setting.
 * Otherwise, for products WITH variants: unavailable only when ALL variants are
 * unavailable. For products WITHOUT variants: checks product-level stock_quantity
 * (only when the tenant's show_out_of_stock setting is on).
 */
export const isUnavailable = (product, storeSettings) => {
  if (product?.branch_unavailable) return true;
  if (product?.is_sold_out) return true;

  const hasVariants = product?.variants && product.variants.length > 0;
  if (hasVariants) {
    const anyAvailable = product.variants.some(v => !isVariantUnavailable(v, storeSettings));
    return !anyAvailable;
  }

  const checkStock = storeSettings?.show_out_of_stock;
  if (!checkStock) return false;

  // No variants — use product-level stock
  if ((product?.stock_quantity ?? null) !== null && product.stock_quantity <= 0) return true;
  return false;
};

/**
 * Check if a specific variant is sold out / unavailable. A variant's own
 * is_sold_out flag is a manual admin override and always wins, regardless of
 * the tenant's show_out_of_stock display setting.
 */
export const isVariantUnavailable = (variant, storeSettings) => {
  if (variant?.is_sold_out) return true;
  if (!storeSettings?.show_out_of_stock) return false;
  return (variant?.stock ?? 100) <= 0;
};
